import React from "react";
import PropTypes from "prop-types";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Divider, Typography, Stack } from "@mui/material";

import { HubIcon } from "../HubIcon";
import { StyledMenuItem } from "./styles";

export const HubContextMenuItem = ({
  item,
  onSelect,
  optionalLabelValue = "label",
  iconProps = {},
  EndComponent,
  ...rest
}) => {
  const onItemSelect = (e) => {
    onSelect && onSelect(e, item);
  };
  if (item?.divider) return <Divider orientation="horizontal" flexItem />;
  if (item?.title)
    return (
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: item?.color || "hubColors.mainText",
          padding: "8px 15px",
        }}
      >
        {item?.title}
      </Typography>
    );

  return (
    <StyledMenuItem
      key={item?.id}
      color={item?.color}
      onClick={onItemSelect}
      {...rest}
    >
      <Stack
        direction="row"
        gap="5px"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Stack direction="row" flexGrow={1} alignItems="center">
          {item?.icon && (
            <ListItemIcon>
              <HubIcon icon={item?.icon} {...iconProps} />
            </ListItemIcon>
          )}
          <ListItemText>{item[optionalLabelValue]}</ListItemText>
        </Stack>
        <Stack>{EndComponent && <EndComponent />}</Stack>
      </Stack>
    </StyledMenuItem>
  );
};

HubContextMenuItem.propTypes = {
  item: PropTypes.object,
  onSelect: PropTypes.func,
  optionalLabelValue: PropTypes.string,
};

export default HubContextMenuItem;
